import React from 'react';
import { Zap } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const LoadingScreen = ({ isMobile }) => {
    const { theme } = useTheme();

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: theme.bg,
            fontFamily: 'monospace',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: '34px',
            padding: '20px'
        }}>
            <div style={{
                animation: 'spin 1s linear infinite',
                fontSize: isMobile ? '55px' : '68px'
            }}>
                <Zap size={isMobile ? 85 : 103} style={{ color: theme.accent }} />
            </div>
            <h2 style={{
                color: theme.accent,
                fontWeight: 'bolder',
                textTransform: 'uppercase',
                margin: '0',
                fontSize: isMobile ? '30px' : '38px',
                textAlign: 'center'
            }}>
                Creating Your Raiku Session...
            </h2>
            <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
        </div>
    );
};

export default LoadingScreen;
